<template>
  <tr>
    <td>{{ item.CreatedAt | dateFormat }}</td>
    <td>{{project.Name}}</td>
    <td>{{processEventContent}}，{{ item.Content }}</td>
    <td>
      <span v-if="item.DoneAt">{{ operator.Profile.Name }}</span>
    </td>
    <td>
      <span v-if="item.DoneAt">{{ item.DoneAt | moment }}</span>
    </td>
    <td>
      <v-btn 
        class="ml-1 mr-1"
        color="white darken-1"
        depressed
        outlined
        text 
        @click.stop="view">檢視</v-btn>

      <v-tooltip
        top
        v-if="!item.DoneAt && isItemActionDetected"
      >
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn
              class="ml-1 mr-1"
              :color="isItemActionDetected ? 'primary':'white darken-1'"
              primary
              depressed
              outlined
              text
              @click.stop="done"
            >Done</v-btn>
          </span>
        </template>
        <span>{{isItemActionDetected}}</span>
      </v-tooltip>
      <v-btn
        v-else-if="!item.DoneAt"
        class="ml-1 mr-1"
        :color="isItemActionDetected ? 'primary':'white darken-1'"
        primary
        depressed
        outlined
        text
        @click.stop="done"
      >Done</v-btn>

    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import redirectMixin from "@/ui/mixin-redirect.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin, redirectMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    project() {
      var project = this.item.project
        
      if (!this.item.project) {
        project = AppDataSetting.findTodoItemProject(this, this.item)
        // this.item.project = project
        this.$set(this.item, 'project', project)
      }
      return project || {}
    },
    operator() {
      return this.users.find(o => o.ID == this.item.DoneBy);
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isItemActionDetected () {
      var isDidSomething = false
      if (this.item.Event.ItemType == 'project') {
        let obj = this.projects.find(o => o.ID == this.item.Event.ItemID) || {}
        // if (!obj.ID) window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown item id: `, this.item.Event.ItemID) 

        if (this.item.Content == "請分配部門預算") {
          isDidSomething = this.projectDepartmentBudgets.find(o => o.ProjectID == this.item.Event.ItemID)
          if (!obj.ID) isDidSomething = '已刪除'
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      } else if (this.item.Event.ItemType == 'taskWorkingItem') {
        let obj = this.taskWorkingItems.find(o => o.ID == this.item.Event.ItemID) || {}
        if (!obj.ID) window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown item id: `, this.item.Event.ItemID) 
        
        if (this.item.Content == "請審核" && this.myLevel > 10) {
          isDidSomething = obj.Status != '獎金簽核中'
        } else if (this.item.Content == "請審核" && this.myLevel == 10) {
          isDidSomething = this.item.Event.Content.includes('回報了工作日誌') && this.item.Status != '主管確認中' || 
            this.item.Event.Content.includes('預排了工作') && this.item.Status != '審核預排中'
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      } else if (this.item.Event.ItemType == 'projectDepartmentBudget') {
        // 提醒主管分配任務
        if (this.item.Content == "請分配任務") {
          isDidSomething = this.tasks.find(o => o.ProjectDepartmentBudgetID == this.item.Event.ItemID)
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      } else if (this.item.Event.ItemType == 'workOrder') {
        // 收受部門確認中 (收受部門安排)
        // 收受部門拒絕 (經理協調)
        // 成果審核中 (發起部門審核)
        // 預算審核中 (經理審核)
        // 獎金審核中 (經理審核)
        let obj = this.workOrders.find(o => o.ID == this.item.Event.ItemID) || {}
        if (this.item.Content == "請確認") {
          isDidSomething = obj.Status != '收受部門確認中'
        } else if (this.item.Content == "請協助協調") {
          // 1. 因為拒絕，需要協調
          let canCloseByReject = obj.Status == "收受部門拒絕"
          // 2. 因為逾時，需要協調
          let canCloseByTimeout = obj.Status == "收受部門確認中" && moment(obj.AlertTime) < moment()
          isDidSomething = !canCloseByReject && !canCloseByTimeout
        } else if (this.item.Content == "請審核成果") {
          isDidSomething = obj.Status != '成果審核中'
        } else if (this.item.Content == "請審核預算") {
          isDidSomething = obj.Status != '預算審核中'
        } else if (this.item.Content == "請審核獎金") {
          isDidSomething = obj.Status != '獎金審核中'
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      } else if (this.item.Event.ItemType == 'leaveForm') {
        let obj = this.leaveForms.find(o => o.ID == this.item.Event.ItemID) || {}
        if (!obj.ID) window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown item id: `, this.item.Event.ItemID) 
        if (this.item.Content == "請審核") {
          if (this.myLevel == 10) isDidSomething = obj.Status != '主管確認中'
          if (this.myLevel == 100) isDidSomething = obj.Status != '人資審核中'
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      } else if (this.item.Event.ItemType == 'compensatoryTime') {
        let obj = this.compensatoryTimes.find(o => o.ID == this.item.Event.ItemID) || {}
        if (!obj.ID) window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown item id: `, this.item.Event.ItemID) 
        if (this.item.Content == "請審核") {
          isDidSomething = obj.Status != '請審核'
        } else {
          window.console.error(`todoItem-list-item.vue, isItemActionDetected, ${this.item.Event.ItemType}, unknown content: `, this.item.Content)
        }
      }/* else if (this.item.Event.ItemType == 'task') {

      } else if (this.item.Event.ItemType == 'user') {

      } else if (this.item.Event.ItemType == 'county') {

      } else if (this.item.Event.ItemType == 'client') {

      } else if (this.item.Event.ItemType == 'department') {

      }*/ else {
        window.console.error(`todoItem-list-item.vue, isItemActionDetected, unknown ItemType: `, this.item.Event.ItemType)
      }
      if (typeof isDidSomething != 'string') isDidSomething = Boolean(isDidSomething) ? '已完成' : false
      return isDidSomething
    },
    processEventContent () {
      var content = this.item.Event.Content
      if (this.item.Event.ItemType == 'project') {
        var projectName = content.match(/「(.*?)」/g)[0]
        var project = this.projects.find(o=>o.ID == this.item.Event.ItemID)
        if (project) {
          if (`「${project.Name}」` != projectName) {
            content = content.replace(/「(.*?)」/g, `「${project.Name}」`)
          }
        }
      }
      return content
    },
    ...mapGetters(["users", "tasks", "leaveForms", "compensatoryTimes", "workOrders", "projectDepartmentBudgets", "myLevel", "taskWorkingItems", "projects"])
  },
  methods: {
    view() {
      this.redirectToTODOItem(this.item);
    },
    done() {
      if (!this.isItemActionDetected) {
        if (window.confirm('系統並未偵測到該事項有進行操作，確認完成?')) {
          this.$emit("done", this.item.ID);
        }
      } else {
        this.$emit("done", this.item.ID);
      }
    }
  }
};
</script>